/**
 * Una clase para interactuar con el plugin
 */

import axios from 'axios';
const C = {
    AccionWrite: "write",
    AccionWriteLF: "writeLF",
    AccionCut: "cut",
    AccionCash: "cash",
    AccionCutPartial: "cutpartial",
    AccionAlign: "align",
    AccionFontSize: "fontsize",
    AccionFont: "font",
    AccionEmphasize: "emphasize",
    AccionFeed: "feed",
    AccionQr: "qr",
    AccionImagen: "imagen",
    AccionHTML: "html",
    AlineacionCentro: "center",
    AlineacionDerecha: "right",
    AlineacionIzquierda: "left",
    FuenteA: "A",
    FuenteB: "B",
    AccionBarcode128: "barcode128",
    AccionBarcode39: "barcode39",
    AccionBarcode93: "barcode93",
    AccionBarcodeEAN: "barcodeEAN",
    AccionBarcodeTwoOfFiveSinInterleaved: "barcodeTwoOfFive",
    AccionBarcodeTwoOfFiveInterleaved: "barcodeTwoOfFiveInterleaved",
    AccionBarcodeCodabar: "barcodeCodabar",
    AccionBarcodeUPCA: "barcodeUPCA",
    AccionBarcodeUPCE: "barcodeUPCE",
    Medida80: 80,
    Medida100: 100,
    Medida156: 156,
    Medida200: 200,
    Medida300: 300,
    Medida350: 350,
};

const URL_PLUGIN = "http://127.0.0.1:8002";

export class OperacionTicket {
    constructor(accion, datos) {
        this.accion = accion + "";
        this.datos = datos;
        if(accion == C.AccionQr)
            this.datos += ",200";//QR 100 es arox 0.95cm
    }
}
export class Impresora {
    constructor(ruta) {
        if (!ruta) ruta = URL_PLUGIN;
        this.ruta = ruta;
        this.operaciones = [];
    }

    static setImpresora(nombreImpresora, ruta) {
        if (ruta) URL_PLUGIN = ruta;
        return fetch(URL_PLUGIN + "/impresora", {
                method: "POST",
                body: JSON.stringify({"impresora": nombreImpresora}),
            })
            .then(r => r.json())
            .then(function(respuestaDecodificada) {
                console.log(respuestaDecodificada);
                return true;
            })
            /*.then(respuestaDecodificada => respuestaDecodificada === nombreImpresora)*/;
    }

    autorizarPago(monto, nombreCajero, referenciaComercio){
        return fetch(URL_PLUGIN + "/autorizarPago", {
            method: "POST",
            headers: {
                "accept": "*/*",
                "content-type": "text/plain;charset=UTF-8",
                "accept-language": "es-419,es;q=0.9",
            },
            body: JSON.stringify({"monto":monto,"nombreCajero":nombreCajero, "referenciaComercio":referenciaComercio}),
        })
        .then(r => r.json());
    }

    parseDate(dateParse){
        const date = dateParse;
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        
        return year+''+String(month).padStart(2, '0')+''+String(day).padStart(2, '0')+''+String(hour).padStart(2, '0')+''+String(minute).padStart(2, '0')+''+String(second).padStart(2, '0');
    }

    static getImpresora(ruta) {
        if (ruta) URL_PLUGIN = ruta;
        return fetch(URL_PLUGIN + "/impresora")
            .then(r => r.json());
    }

    static getImpresoras(ruta) {
        if (ruta) URL_PLUGIN = ruta;
        return fetch(URL_PLUGIN + "/impresoras")
            .then(r => r.json());
    }

    cut() {
        this.operaciones.push(new OperacionTicket(C.AccionCut, ""));
    }

    cash() {
        this.operaciones.push(new OperacionTicket(C.AccionCash, ""));
    }

    cutPartial() {
        this.operaciones.push(new OperacionTicket(C.AccionCutPartial, ""));
    }

    setFontSize(a, b) {
        this.operaciones.push(new OperacionTicket(C.AccionFontSize, `${a},${b}`));
    }

    setFont(font) {
        if (font !== C.FuenteA && font !== C.FuenteB) throw Error("Fuente inválida");
        this.operaciones.push(new OperacionTicket(C.AccionFont, font));
    }
    setEmphasize(val) {
        if (isNaN(parseInt(val)) || parseInt(val) < 0) throw Error("Valor inválido");
        this.operaciones.push(new OperacionTicket(C.AccionEmphasize, val));
    }
    setAlign(align) {
        if (align !== C.AlineacionCentro && align !== C.AlineacionDerecha && align !== C.AlineacionIzquierda) {
            throw Error(`Alineación ${align} inválida`);
        }
        this.operaciones.push(new OperacionTicket(C.AccionAlign, align));
    }

    write(text) {
        this.operaciones.push(new OperacionTicket(C.AccionWrite, text));
    }

    writeLF(text) {
        this.operaciones.push(new OperacionTicket(C.AccionWriteLF, text));
    }

    imagen(dato){
        this.operaciones.push(new OperacionTicket(C.AccionImagen, dato));
    }

    html(dato){
        this.operaciones.push(new OperacionTicket(C.AccionHTML, dato));
    }

    feed(n) {
        if (!parseInt(n) || parseInt(n) < 0) {
            throw Error("Valor para feed inválido");
        }
        this.operaciones.push(new OperacionTicket(C.AccionFeed, n));
    }

    end() {
        return fetch(this.ruta + "/imprimir", {
            method: "POST",
            headers: {
                'Accept': 'text/plain; text/html; charset=utf-8',
                'Content-Type': 'text/plain; text/html; charset=utf-8',
            },
            body: JSON.stringify(this.operaciones),
        })
        .then(r => r.json()).catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
        });
    }

    imprimirEnImpresora(nombreImpresora) {
        const payload = {
            operaciones: this.operaciones,
            impresora: nombreImpresora,
        };
        return fetch(this.ruta + "/imprimir_en", {
                method: "POST",
                body: JSON.stringify(payload),
                headers: {
                    //'Accept': 'application/vnd.api+json',
                    'Content-Type': 'text/plain; charset=utf-8',
                }
            })
            .then(r => r.json());
    }

    qr(contenido) {
        this.operaciones.push(new OperacionTicket(C.AccionQr, contenido));
    }

    validarMedida(medida) {
        medida = parseInt(medida);
        if (medida !== C.Medida80 &&
            medida !== C.Medida100 &&
            medida !== C.Medida156 &&
            medida !== C.Medida200 &&
            medida !== C.Medida300 &&
            medida !== C.Medida350) {
            throw Error("Valor para medida del barcode inválido");
        }
    }

    validarTipo(tipo) {
        if (
            [C.AccionBarcode128,
                C.AccionBarcode39,
                C.AccionBarcode93,
                C.AccionBarcodeEAN,
                C.AccionBarcodeTwoOfFiveInterleaved,
                C.AccionBarcodeTwoOfFiveSinInterleaved,
                C.AccionBarcodeCodabar,
                C.AccionBarcodeUPCA,
                C.AccionBarcodeUPCE,
            ]
            .indexOf(tipo) === -1
        ) throw Error("Tipo de código de barras no soportado");
    }

    barcode(contenido, ancho, alto, tipo) {
        let payload = contenido.concat(",").concat(ancho.toString()).concat(",").concat(alto.toString());
        this.operaciones.push(new OperacionTicket(tipo, payload));
    }

}